/**
 * نصوص الصلاحيات والمعاينة: شريط «معاينة» فوق الصفحات المقفلة (DemoBanner)،
 * بطاقة القفل (LockedCard) وحارس الصفحات المهنية (ProfessionalRoute).
 * تُستخدم عبر useTranslation('gating').
 */
const gating = {
  preview: 'معاينة',
  checking: 'جارٍ التحقق من صلاحية الوصول…',

  demo: {
    title: 'أنت تشاهد معاينة',
    body: 'تعرض هذه الصفحة بيانات حقيقية لمثال واحد: حي {{district}} في {{city}}. لتغيير المدينة أو الحي أو المدخلات:',
    bodyNoPlace: 'تعرض هذه الصفحة بيانات حقيقية لمثال واحد. لتغيير المدينة أو الحي أو المدخلات:',
    place: 'المثال: حي {{district}}، {{city}}',
    regionLabel: 'معاينة {{feature}}',
    signIn: 'سجّل الدخول',
    createAccount: 'أنشئ حساباً',
    buyAddon: 'اشترِ إضافة مؤشرات السوق',
    subscribe: 'اطّلع على الباقات',
    contactAdmin: 'تواصل مع مدير شركتك لتفعيل الاشتراك',
    subscribersOnly: 'مؤشرات السوق متاحة لمشتركي باقات الوسطاء والشركات',
    planNotIncluded: 'باقتك الحالية لا تشمل مؤشرات السوق',
    example: 'مثال',
  },

  pro: {
    title: 'للحسابات المهنية',
    body: 'هذه الصفحة متاحة للوسطاء والشركات والمطوّرين والمختصين العقاريين.',
    upgrade: 'طوّر حسابك',
    register: 'سجّل كمهني',
    backHome: 'العودة إلى الرئيسية',
    checkFailed: 'تعذّر التحقق من نوع حسابك',
    checkFailedBody: 'تحقّق من اتصالك بالإنترنت ثم أعد المحاولة.',
    retry: 'إعادة المحاولة',
  },
};

export default gating;
